module.exports = __webpack_public_path__ + "img/map_add.5d504e75.svg";